enum CustomStackRankMetricsCreationSettingValue {
  OWNER = "owner",
  OWNER_MANAGER = "owner-manager",
}

export default CustomStackRankMetricsCreationSettingValue;
